import { Region } from "../core/services/ebr-api-client/ebr-api-client.g";
import { Filters } from "./filter-model";

export type ContractModelBody = {
    division : string,
    dataView: string,
    topLevelContractGroup: string[] | undefined,
    secondLevelContractFilter: string[] | undefined,
    thirdLevelContractFilter: string[] | undefined,
    fourthLevelContractFilter: string[] | undefined,
    accts: string[] | undefined,
    excludeDeletedAccounts: boolean
}


export type GraphData = {
  legends: string[],
  data: any[]
}

export type Alert = {
  id: any,
  message: string
}


export type SmartpowerLocation = {
  AgreementNumber: string,
  AgreementName: string,
  AccountNumber: string,
  UnitNumber: string,
  AccountName: string,
  Address: string,
  Period: string,
  Value: string
}

export type Country = {
  name: string,
  code: string
}


export type FilterRecallRecord = {
  filterName: string,
  region: string,
  accountName: string,
  lastUsed: string,
  lastChanged: string,
  dateCreated: string,
}

// Region mapping from One Customer to EBR
export const ONE_CUSTOMER_TO_EBR_REGION_MAP: { [key: string]: string } = {
  'ASIA PACIFIC REGION': 'AP',
  'IMEA': 'IMEA',
  'NORTH AMERICA REGION': 'NA',
  'LATIN AMERICA REGION': 'LA',
  'EUROPE EXCLUDING RUSSIA': 'EU',
  'GREATER CHINA REGION': 'CHINA_NOT_SUPPORTED'
};

// Region enum to display name mapping
export const regionDisplayNames: Record<Region, string> = {
    [Region.NA]: 'North America',
    [Region.EU]: 'Europe',
    [Region.LA]: 'Latin America',
    [Region.AP]: 'Asia Pacific',
    [Region.IMEA]: 'India, Middle East & Africa',
  };

export type Money = {
  value : number,
  currencyCodeId : string,
}

export type Measurement = {
    value: number, 
    unitOfMeasureSystem : string, //UnitOfMeasureTypes enum
    unitOfMeasure : string, //UnitOfMeasurement enum
}


